import type {
  ComponentProps,
} from "react";

import * as LabelPrimitive from "@radix-ui/react-label";

import { cn } from "@/lib/utils";

export function Label({ ref, className, ...props }: ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      ref={ref}
      className={cn(
        "text-sm leading-none tracking-tight text-neutral-300 peer-disabled:cursor-not-allowed",
        className,
      )}
      {...props}
    />
  );
}
